import { render, staticRenderFns } from "./DrvFilterBadges.vue?vue&type=template&id=697ea0ce"
import script from "./DrvFilterBadges.vue?vue&type=script&lang=js"
export * from "./DrvFilterBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports